// extracted by mini-css-extract-plugin
export default {"tabContainer":"NSe-kgnQWjgWZYhw9DTwKA==","text":"Fd6wgBx72vXELTK38fDrkg==","countBadge":"x19LIlQ+Kr20pNvXRc4Exg=="};